import {ReelsCascadingModule, ReelsCascadingStates, ReelsCascadingView} from '@gongxigames/framework/slot';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class ReelsCascadingCollapseState extends ModuleState<ReelsCascadingView, ReelsCascadingModule> {
    protected setupEvents(): void {
        this.setEventHandler('General.READY_FOR_BASE_FLOW', this.onReadyForBaseFlow.bind(this));
    }

    public onEnterState(): void {
        this.emit('General.ACTIVATE_COLLAPSING');
        this.view.setAllSymbolsVisible(false);
    }

    public onLeaveState(): void {}

    private onReadyForBaseFlow(symbolIds: number[][]): void {
        symbolIds.forEach((reel, reelIndex) =>
            reel.forEach((symbolId, rowIndex) =>
                this.view.updateSymbol(symbolId, {x: reelIndex, y: rowIndex})));

        this.view.setAllSymbolsVisible(true);
        this.module.gotoState(ReelsCascadingStates.BASIC_STATE);
    }
}